import Head from "next/head";

export function FavIcon() {
  return (
    <Head>
      <title>ECN</title>
      <meta content="ECN" name="description" />
      <link
        href="/favicon/favicon-16x16.png"
        rel="icon"
        sizes="16x16"
        type="image/png"
      />
      <link
        href="/favicon/favicon-32x32.png"
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href="/favicon/favicon.ico"
        rel="icon"
        sizes="48x48"
        type="image/x-icon"
      />
      <link
        href="/favicon/android-chrome-192x192.png"
        rel="icon"
        sizes="192x192"
        type="image/png"
      />
      <link
        href="/favicon/android-chrome-512x512.png"
        rel="icon"
        sizes="512x512"
        type="image/png"
      />
      <link
        href="/favicon/apple-touch-icon.png"
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        crossOrigin="use-credentials"
        href="/favicon/site.webmanifest"
        rel="manifest"
      />
    </Head>
  );
}
